import { fetchQuery } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';
import { Environment } from 'react-relay';

import { launchTradeGeneralOnboarding } from './launchTradeGeneralOnboarding';
import { tradeGeneralOnboardingQuery } from './tradeGeneralOnboardingQuery';
import { hasSeenTradeGeneralOnboarding, isDesktop, isUserTypeTrade } from './helpers';

import {
    tradeGeneralOnboardingQueryResponse,
    tradeGeneralOnboardingQuery as QueryType,
} from './__generated__/tradeGeneralOnboardingQuery.graphql';

export const tradeGeneralOnboardingRule = async ({
    relayEnvironment,
}: {
    relayEnvironment: Environment;
}): Promise<boolean> => {
    const userId = getBuyerId(document.cookie);

    if (!userId || !isUserTypeTrade() || !isDesktop() || hasSeenTradeGeneralOnboarding()) {
        return Promise.resolve(false);
    }

    const response: tradeGeneralOnboardingQueryResponse = await fetchQuery<QueryType>(
        relayEnvironment,
        tradeGeneralOnboardingQuery,
        { userId }
    );

    const isNewTradeUser =
        response.viewer?.user?.verifiedTradeSubStatus === 'VERIFIED_IN_LAST_30_DAYS';
    return isNewTradeUser;
};

export const tradeGeneralOnboardingConfig = {
    name: 'tradeGlobalOnboarding',
    rule: tradeGeneralOnboardingRule,
    action: launchTradeGeneralOnboarding,
    priority: 450,
};
